/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Fragment from 'ember-data-model-fragments/fragment';
import { attr } from '@ember-data/model';

export default class ArticleLink extends Fragment {
  @attr('string') declare article_id: string;
  @attr('string') declare type: 'article-link';
}
